const previewRegex = /^deploy-preview-(\d+)--whoosh-patron-master.netlify.app$/;
const demoApiHost = "api.demo.whoosh.io";
const gkeReviewApiDomain = "review.whoosh.io";
// This is just a publicly available endpoint to ensure the server is running.
const reviewApiAvailabilityPath = "/.well-known/openid-configuration";
const reviewApiAvailabilityTimeoutMs = 1500;

export const getReviewApiHost = (feHost: string) => {
  const matches = feHost.match(previewRegex);

  if (matches) {
    const prNumber = matches[1];
    return `${prNumber}.${gkeReviewApiDomain}`;
  } else {
    return null;
  }
};

let webAPIHostPromise: Promise<string> | null = null;
export const resetWebApiHostCacheForTests = () => {
  webAPIHostPromise = null;
};

export const getWebApiHost = ({ isE2E }: { isE2E?: boolean }) => {
  if (!webAPIHostPromise) {
    webAPIHostPromise = calculateWebApiHost({ isE2E }).catch(
      (error: unknown) => {
        webAPIHostPromise = null;
        throw error;
      }
    );
  }

  return webAPIHostPromise;
};

const isReviewApiHostAvailable = async (reviewApiHost: string) => {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(
    () => controller.abort(),
    reviewApiAvailabilityTimeoutMs
  );

  try {
    const response = await window.fetch(
      `https://${reviewApiHost}${reviewApiAvailabilityPath}`,
      {
        cache: "no-store",
        method: "HEAD",
        signal: controller.signal,
      }
    );

    return response.ok;
  } catch (_error) {
    return false;
  } finally {
    window.clearTimeout(timeoutId);
  }
};

const getAvailableReviewApiHost = async (reviewApiHosts: string[]) => {
  for (const reviewApiHost of reviewApiHosts) {
    if (await isReviewApiHostAvailable(reviewApiHost)) {
      return reviewApiHost;
    }
  }

  return demoApiHost;
};

const calculateWebApiHost = async ({ isE2E }: { isE2E?: boolean }) => {
  const host = window.location.host;
  if (!host) {
    return "";
  }
  const reviewApiHost = getReviewApiHost(host);

  const isLocal = host.includes("localhost");
  /**
   * Since we build local with metro now -- we no longer proxy our calls and must
   * directly call localhost:4000 to hit our local backend
   */
  if (isLocal || isE2E) {
    return "http://localhost:4000";
  }
  if (host === "localhost:3000" || host === "127.0.0.1:3000") {
    return "";
  } else if (reviewApiHost) {
    return getAvailableReviewApiHost([reviewApiHost]);
  } else {
    return `api.${host}`;
  }
};
